import React from "react";
import moment from "moment";
import { styled } from "@mui/material/styles";
import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import Modal from "@/components/modal";
import { toast } from "sonner";
import { useDeleteHeroModelMutation } from "@/app/features/HeroModel/HeroModelApiSlice";

const CarDetails = styled(Box)`
  overflow-y: auto;
  height: 80px;
`;

function CarRow({ name, value }) {
  return (
    <Grid container mb={1}>
      <Grid item xs={12} sm={2}>
        {name}
      </Grid>

      <Grid item xs={12} sm={10}>
        {value}
      </Grid>
    </Grid>
  );
}

export default function HeroModelModal({
  open,
  handleClose,
  selectedHeroModel,
}) {
  const [deletePost, { isLoading }] = useDeleteHeroModelMutation();

  const handleDelete = async () => {
    try {
      await deletePost(selectedHeroModel.id);
      handleClose();
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Typography
        variant="h6"
        sx={{
          mb: 2,
        }}
      >
        Are you sure you want to delete {selectedHeroModel.carId} ?
      </Typography>

      <CarDetails>
        <CarRow name="carId" value={selectedHeroModel.carId} />

        <CarRow
          name="Created On"
          value={moment(selectedHeroModel.createdAt).format("MMMM Do YYYY")}
        />
      </CarDetails>

      <Stack direction="row" alignItems="center" justifyContent="center" mt={2}>
        <Button
          variant="contained"
          fullWidth
          onClick={handleDelete}
          disabled={isLoading}
        >
          Delete
        </Button>
      </Stack>
    </Modal>
  );
}
